import React from "react";
import { LinearProgress, Box, Skeleton, Stack } from "@mui/material";
import { Layout } from "./Layout";

interface LoadingPageProps {
  title?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ title = "" }) => {
  return (
    <Layout title={title}>
      <LinearProgress
        sx={{
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#6095c6",
            borderRadius: 1,
          },
          backgroundColor: "rgba(96, 149, 198, 0.1)",
          height: 2,
          borderRadius: 1,
          mb: 4,
          overflow: "hidden",
        }}
      />
      <Box sx={{ width: "100%", mt: 2 }}>
        <Stack spacing={3} sx={{ mt: 3 }}>
          <Skeleton
            variant="rectangular"
            height={60}
            sx={{
              borderRadius: 2,
              opacity: 0.3,
            }}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            height={200}
            sx={{
              borderRadius: 2,
              opacity: 0.3,
            }}
            animation="wave"
          />
          <Stack direction="row" spacing={2}>
            <Skeleton
              variant="rectangular"
              height={120}
              sx={{
                borderRadius: 2,
                flex: 1,
                opacity: 0.3,
              }}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              height={120}
              sx={{
                borderRadius: 2,
                flex: 1,
                opacity: 0.3,
              }}
              animation="wave"
            />
          </Stack>
        </Stack>
      </Box>
    </Layout>
  );
};
